import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconZapOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, p = ["aria-label", "data-qa", "aria-hidden"], c = ["clip-path"], m = ["id"];
function _(e, t, r, h, g, i) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--zap-off"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Zap Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M6.699.541a.5.5 0 0 1 .297.52l-.295 2.376a.5.5 0 0 1-.992-.124l.085-.683-.125.15a.5.5 0 0 1-.768-.64L6.116.68a.5.5 0 0 1 .583-.139ZM7.33 5a.5.5 0 0 1 .5-.5h2.67a.5.5 0 0 1 .384.82L9.669 6.777a.5.5 0 0 1-.768-.641l.53-.635H7.83a.5.5 0 0 1-.5-.5Zm-1.446 6.32a.5.5 0 0 1-.88-.382l.43-3.438H1.5a.5.5 0 0 1-.384-.82l2.208-2.65L.646 1.355a.5.5 0 1 1 .708-.708l10 10a.5.5 0 0 1-.708.708L8.034 8.74l-2.15 2.58Zm.324-1.95.272-2.182.844.843L6.208 9.37ZM5.793 6.5H2.568l1.466-1.76L5.793 6.5Z" }, null, -1)
    ])], 8, c),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, p);
}
const b = /* @__PURE__ */ u(f, [["render", _]]);
export {
  b as default
};
//# sourceMappingURL=zap-off.js.map
